module.exports = "/_next/static/images/594fac58a226b484c39a3f03cfc55f2c-mulher-com-cachos-maravilhosos-segurando-cartao-lg@3x.jpg";